import React from 'react';
import {
  RecommendationsRow,
  AnyoneCanSellRow,
  TrendingSearches,
  HomepageEmbed,
  Categories,
  Articles,
  NewsletterSignup,
  NewGearRow,
  DealsAndSteals,
  SellYourGear,
  HomepageSearchRecommendations,
  DealsAndStealsForYou,
} from './logged_out/content_components';

import { withMpid, MpidProps } from '@reverbdotcom/commons/src/with_mpid';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { experimentInt } from '@reverbdotcom/commons/src/user_context_helpers';

export function DefaultLoggedOutHomepage() {
  return (
    <>
      <div className="mb-gap-row">
        <CmsEmbed slug="logged-out-homepage" ssrMode="full" />
      </div>
      <RecommendationsRow />
      <AnyoneCanSellRow />
      <TrendingSearches />
      <HomepageEmbed />
      <Categories />
      <Articles />
      <NewsletterSignup />
      <NewGearRow />
      <DealsAndSteals />
      <SellYourGear />
    </>
  );
}

export function SlimHomepageRedesign() {
  return (
    <>
      <div className="mb-gap-row">
        <CmsEmbed slug="logged-out-homepage-redesign" ssrMode="full" />
      </div>
      <HomepageSearchRecommendations />
    </>
  );
}

export function ExpandedHomepageRedesign({ mpid }) {
  return (
    <>
      <div className="mb-gap-row">
        <CmsEmbed slug="logged-out-homepage-redesign" ssrMode="full" />
      </div>
      <HomepageSearchRecommendations />
      <DealsAndStealsForYou mpid={mpid}/>
    </>
  );
}

function LoggedOutHomepage(props: MpidProps) {
  const user = useUser();
  const expGroup = experimentInt(user, experiments.LOGGED_OUT_HOMEPAGE_REDESIGN);

  if (expGroup === 1) {
    return <SlimHomepageRedesign />;
  }
  if (expGroup === 2) {
    return <ExpandedHomepageRedesign mpid={props.mpid} />;
  }

  return <DefaultLoggedOutHomepage/>;
}

export default withMpid<MpidProps>(LoggedOutHomepage);
